// removed by extract-text-webpack-plugin
module.exports = {"contact":"_2RPweGychXjREgVi6-G-m7","limitUnavailable":"_1u1cU-K3DNlzR3RA7UtT7u"};


//////////////////
// WEBPACK FOOTER
// ./work/styles.module.css
// module id = 736
// module chunks = 0